import { render, staticRenderFns } from "./MemberClassesWare.vue?vue&type=template&id=f235e6b0&scoped=true&"
import script from "./MemberClassesWare.vue?vue&type=script&lang=js&"
export * from "./MemberClassesWare.vue?vue&type=script&lang=js&"
import style0 from "./MemberClassesWare.vue?vue&type=style&index=0&id=f235e6b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f235e6b0",
  null
  
)

export default component.exports